import type { ResourceTimingsConfig } from "../types";

let config: ResourceTimingsConfig = {
    mapResources: (url: string) => url,
    sanitiseEndpoints: (url: string) => url
};

export function configure(resourceTimingConfig: ResourceTimingsConfig) {
    config = resourceTimingConfig;
}

export const getConfig = () => config;
